import { LockIcon } from "@carbon6/c6-frontend-design/icons";
import type { DatasetStorageBackend } from "@/api/datasetStorageBackend";
import { storageBackendLabel } from "@/components/dataset/storageBackendText";
import lockStyles from "./AnnotationSetLockOverlay.module.css";
import styles from "./AnnotationStudioTab.module.css";

/**
 * Annotation 을 지원하지 않는 저장 위치의 Dataset 에서 스튜디오 대신 그리는 탭 본문.
 *
 * 탭을 끄거나 숨기지 않는다. Annotation 으로 오는 길(탭, 세트 딥링크, Session 의 세트 표식, 제출
 * 위저드의 링크)이 모두 이 탭에 도착한다. 그래서 어느 길로 와도 같은 사유를 본다. 세트는 조회하지
 * 않는다. 조회하면 409 다. 카드는 GPU 없음·확정 세트 잠금과 같은 모양이다.
 */
export function AnnotationStorageLock({ backend }: { backend: DatasetStorageBackend }) {
  return (
    <section className={`${styles.tab} ${styles.locked}`} aria-label="Annotation 스튜디오">
      <div className={lockStyles.card} role="status">
        <span className={lockStyles.heading}>
          <LockIcon aria-hidden="true" />
          {storageBackendLabel(backend)}에 저장된 Dataset입니다
        </span>
        <p className={lockStyles.body}>이 저장 위치는 Annotation 기능을 지원하지 않습니다.</p>
      </div>
    </section>
  );
}
